import React from 'react';

const HomeWhyBest = () => {
    return (
        <div className="md:mx-auto md:container px-4">
            <div className="pt-10 md:pt-40">
                <div className="container mx-auto">
                    <div className="flex flex-wrap items-center pb-12">
                        <div className="md:w-1/2 lg:w-2/3 w-full xl:pr-20 md:pr-6">
                            <div className="py-2 text-color">
                                <h1 className="text-4xl md:leading-snug font-black">
                                    Why I'am best photographer?
                                </h1>
                                <h2 className="text-lg py-4 md:py-8">
                                    Years ago, when I worked as a professional
                                    photographer, I thought I was good. That was
                                    because my customers were happy with what I
                                    produced, they referred other people to me
                                    and returned to do business repeatedly.
                                    Nowadays I’m not so sure. That’s because my
                                    customer base is much, much smaller, almost
                                    entirely limited to myself, my friends and
                                    family. The last two groups have no
                                    complaints about my work, but that first
                                    guy, he’s a real stickler. It’s like he
                                    knows exactly what I wanted to do and where
                                    I failed, every time. He often knows just
                                    where I mess up but, strangely, it’s when he
                                    doesn’t that things get really frustrating.
                                </h2>
                            </div>
                        </div>
                        <div className="lg:w-1/3 md:w-1/2 w-full relative h-96 flex items-end justify-center">
                            <img
                                className="absolute w-full h-full inset-0 object-cover object-center rounded-md"
                                src="https://images.unsplash.com/photo-1620403724129-23fc81e1e0df?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NXx8Y2FtZXJhJTIwbWFufGVufDB8MHwwfHw%3D&auto=format&fit=crop&w=500&q=60"
                                alt=""
                            />
                            <div className="relative z-10 bg-white rounded shadow p-6 w-10/12 -mb-20">
                                <div className="flex items-center justify-between w-full sm:w-full mb-8">
                                    <div className="flex items-center">
                                        <div className="p-4 bg-yellow-200 rounded-md">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="icon icon-tabler icon-tabler-discount"
                                                width={32}
                                                height={32}
                                                viewBox="0 0 24 24"
                                                strokeWidth="1.5"
                                                stroke="currentColor"
                                                fill="none"
                                                strokeLinecap="round"
                                                strokeLinejoin="round">
                                                <path
                                                    stroke="none"
                                                    d="M0 0h24v24H0z"
                                                />
                                                <line
                                                    x1={9}
                                                    y1={15}
                                                    x2={15}
                                                    y2={9}
                                                />
                                                <circle
                                                    cx="9.5"
                                                    cy="9.5"
                                                    r=".5"
                                                />
                                                <circle
                                                    cx="14.5"
                                                    cy="14.5"
                                                    r=".5"
                                                />
                                                <path d="M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7a2.2 2.2 0 0 0 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1a2.2 2.2 0 0 0 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55 v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55 v-1" />
                                            </svg>
                                        </div>
                                        <div className="ml-6">
                                            <h3 className="mb-1 leading-5 text-gray-800 font-bold text-2xl">
                                                2,330
                                            </h3>
                                            <p className="text-gray-600 text-sm tracking-normal font-normal leading-5">
                                                Avg Sales My Photography
                                            </p>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="flex items-center pl-3 text-green-400">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="icon icon-tabler icon-tabler-trending-up"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                strokeWidth="1.5"
                                                stroke="currentColor"
                                                fill="none"
                                                strokeLinecap="round"
                                                strokeLinejoin="round">
                                                <path
                                                    stroke="none"
                                                    d="M0 0h24v24H0z"
                                                />
                                                <polyline points="3 17 9 11 13 15 21 7" />
                                                <polyline points="14 7 21 7 21 14" />
                                            </svg>
                                            <p className="text-green-400 text-xs tracking-wide font-bold leading-normal pl-1">
                                                7.2%
                                            </p>
                                        </div>
                                        <p className="font-normal text-xs text-right leading-4 text-green-400 tracking-normal">
                                            Increase
                                        </p>
                                    </div>
                                </div>
                                <div className="relative mb-3">
                                    <hr className="h-1 rounded-sm bg-gray-200" />
                                    <hr className="absolute top-0 h-1 w-7/12 rounded-sm bg-indigo-700" />
                                </div>
                                <h4 className="text-base text-gray-600 font-normal tracking-normal leading-5">
                                    My Yearly Goal
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="pb-32 pt-16">
                <div className="mx-auto">
                    <div className="flex flex-wrap flex-row-reverse items-center">
                        <div className="md:w-1/2 lg:w-2/3 w-full lg:pl-20 md:pl-10 sm:pl-0 pl-0">
                            <div className="py-2 text-color">
                                <h1 className="text-2xl lg:text-4xl  font-black">
                                    Why am I for you?
                                </h1>
                                <h2 className="text-lg  py-8">
                                    Whether I am “good” or not I think is not
                                    for me to say. I will assert that I am still
                                    as competent a craftsman as I ever was. I
                                    still do event photography and I still
                                    deliver. I have skills. I not only can work
                                    a camera but I am skilled in both Lightroom
                                    and Photoshop, essential as I shoot only
                                    raw. I know what I'm doing. But good?
                                </h2>
                            </div>
                        </div>
                        <div className="lg:w-1/3 md:w-1/2 w-full relative h-96 flex items-end justify-center">
                            <img
                                className="absolute w-full h-full inset-0 object-cover object-center rounded-md"
                                src="https://images.unsplash.com/photo-1620981468099-f3170a81e471?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTF8fGNhbWVyYSUyMG1hbnxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60"
                                alt=""
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomeWhyBest;
